import { Fyis, Style } from '@local/client-contracts';

export interface SyncingStateData {
  appId: string;
  status: Fyis.SyncStatus;
  linkId: string;
  location: string;
}

export interface SyncingStateDisplayData {
  icon?: Style.EntityIcon<Style.EntityIconType> | Style.Icon;
  title: string;
  subtitle?: string;
  account?: {
    name: string;
    icon: Style.EntityIcon<Style.EntityIconType>;
  };
  note?: string;
}

export type SyncingStatesEventLabels = {
  [status in Fyis.SyncStatus]: string;
};

export const EVENT_LABELS: SyncingStatesEventLabels = {
  Failed: 'synced_failed',
  Started: 'preparing_for_syncing',
  Succeeded: 'no_resources_synced',
};
